export const IFTA_STATUSES = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    ERROR: 'ERROR',
    DONE: 'DONE',
};

export const GEOFENCING_COMPANIES_IDS = [1875, 2863, 2935, 1328];
